export default {
    UNPAID: 0,
    CANCELED: 1,
    EXPIRED: 2,
    PAID: 3,
    CLOSED: 4,
    OPEN: 5,
}